import manufacturers from "./SwitchGearManufacturers.json";

export const SwitchGearConstants = {
  manufacturers: manufacturers.map((m) => m.manufacturer),
  operatingVoltages: [3.3, 6.6, 10, 11, 22, 33],
  ratedVoltages: [3.6, 7.2, 12, 13.8, 17.5, 24, 35, 36, 40.5, 52, 72.5, 100, 123, 145, 170, 245],
  insulationTypeKeys: ["$INSU_AIR", "$INSU_OIL", "$INSU_COMP", "$INSU_SF6"],
  switchGearTypesByManufacturer(manufacturer: string | undefined): string[] {
    if (!manufacturer) {
      return [];
    }

    const foundTypes = manufacturers.find((m) => m.manufacturer === manufacturer)?.types;
    return foundTypes ?? [];
  },
};
